import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getChild, } from '../reducer';
import { withNamespaces } from 'react-i18next';
import { Tabs, Tab, Row, Col, Nav, NavItem } from 'react-bootstrap';
import { Link, Switch, Route } from 'react-router-dom';
import History from './History';
import MedicalInformation from './MedicalInformation';
import MakeupSummary from './MakeupSummary';
import PersonalDetails from './PersonalDetails';
import ui from '../../common/services/ui';
import Card from '../../common/components/Card';
import FontAwesome from 'react-fontawesome';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleMenuOptionSelect = this.handleMenuOptionSelect.bind(this);
	}

	handleMenuOptionSelect(key) {
		const { child } = this.props;
		if (child) {
			this.props.history.push(`/children/${child.id}/${key}`);
		}
	}

	render() {
		const { child, enableCollectMedicalInformation, enableMakeUps, activeTab, t } = this.props;

		const avatarStyle = { width: 64, height: 64, lineHeight: '64px', fontSize: 22, display: 'inline-block', marginBottom: 15 };
		const avatarColors = ['bg-purple', 'bg-green', 'bg-orange', 'bg-blue'];

		return <Row className='clearfix'>
			<Col md={3}>
				<Card className='child-details-sidebar'>
					{child && <div className='child-profile bg-light'>
						<div className={`circle-icon text-white ${avatarColors[child.id % avatarColors.length]}`} style={avatarStyle}>{ui.getAvatarName(child.firstName, child.lastName)}</div>
						<h4>{child.fullName}</h4>
					</div>}
					<Nav bsStyle='pills' stacked activeKey={activeTab} onSelect={this.handleMenuOptionSelect}>
						<NavItem eventKey='personal'><FontAwesome name='user' /> {t('FO_Child_PersonalDetails')}</NavItem>
						{enableCollectMedicalInformation && <NavItem eventKey='medical-information'><FontAwesome name='medkit' /> {t('FO_Child_MedicalInformation')}</NavItem>}
						<NavItem eventKey='history'><FontAwesome name='history' /> {t('FO_Child_History')}</NavItem>
						{enableMakeUps && <NavItem eventKey='make-up-summary'><FontAwesome name='random' /> {t('FO_Child_MakeupSummary')}</NavItem>}
					</Nav>
				</Card>
			</Col>
			<Col md={9}>
				<div className='child-details-content'>
					<Switch>
						<Route path={'/children/:id'} exact component={PersonalDetails} />
						<Route path={'/children/:id/personal'} exact component={PersonalDetails} />
						<Route path={'/children/:id/medical-information'} component={MedicalInformation} />
						<Route path={'/children/:id/history'} component={History} />
						<Route path={'/children/:id/make-up-summary'} component={MakeupSummary} />
					</Switch>
				</div>
			</Col>
		</Row>;
	}
};

const mapStateToProps = (state, ownProps) => {
	const { configuration: { franchisor } } = state;

	const childId = Number(ownProps.match.params.id);
	const child = getChild(state.parent, childId);

	return {
		child,
		enableCollectMedicalInformation: franchisor && franchisor.enableCollectMedicalInformation,
		enableMakeUps: franchisor && franchisor.enableMakeUps,
		activeTab: ownProps.match.params.tab || 'personal'
	};
};

export default connect(mapStateToProps, {})(withNamespaces()(Details));